import footerTemplateHtml from "../templates/footer-sale";
import {
  updateClassNames,
  isUserLoggedIn,
  appendCountryLanguage,
  initializeLightbox,
  hideElementInIframe,
  showAppStore,
  addEmailSignupLinkClickListeners,
  getCountry,
  getLanguage,
  toggleForStaff,
  isWebview,
  getIsStaffUser,
  getIsAuthenticated,
} from "./GeneralHelpers";
import { setLinkClickedAnalyticsListeners } from "./Analytics";

class FooterSale extends HTMLElement {
  constructor() {
    super();

    if (!isWebview()) {
      this.root = this.attachShadow({ mode: "open" });
    }
  }

  connectedCallback() {
    this.connectedCallbackRequired();

    if (isWebview()) {
      // Mobile specific logic here
      // ...
      // ...
    } else {
      this.connectedCallbackUI();
    }
  }

  connectedCallbackRequired() {
    this.country = getCountry(this);
    this.language = getLanguage(this);
    this.isStaffUser = getIsStaffUser(this);
    this.isAuthenticated = getIsAuthenticated(this);
  }

  connectedCallbackUI() {
    // Add footer content to body
    const footerTemplate = document.createElement("template");
    const translations = require(`../../utils/translation-data_${this.language}.js`).data;
    footerTemplate.innerHTML = footerTemplateHtml(translations, this.country, this.language, this.isStaffUser);
    this.root.appendChild(footerTemplate.content.cloneNode(true));

    showAppStore(this.root, LANGUAGE.toUpperCase());
    updateClassNames(this.root, ".SALE", this.country, this.language);
    this.addLanguageToRecallLink(this.root, this.language);
    this.bindEvents(this.root);
    addEmailSignupLinkClickListeners(this.root, this.country);
    isUserLoggedIn(this.root, ".SALE", this.isAuthenticated);
    isUserLoggedIn(document, "body", this.isAuthenticated);
    appendCountryLanguage(this.root, this.country, this.language);
    initializeLightbox(document);
    initializeLightbox(this.root);
    hideElementInIframe(this.root, ".SALE");

    this.root.querySelectorAll(".footer-ftue .country").forEach(el => {
      el.innerHTML = this.country.toUpperCase();
    });
    this.root.querySelectorAll(".footer-ftue .language").forEach(el => {
      el.innerHTML = this.language.toUpperCase();
    });
  }

  bindEvents(el) {
    el.querySelectorAll(".footer-ftue .flag").forEach(el => {
      el.classList.add(`flag-${this.country.toUpperCase()}`);
      el.addEventListener("click", () => {
        const flagEv = new Event("ARCTERYXUICOMPONENTS.localeClick", { bubbles: true, cancelable: false });
        flagEv.initEvent("ARCTERYXUICOMPONENTS.localeClick", true, true);
        this.dispatchEvent(flagEv);
      });
    });

    el.querySelectorAll(".footer-ftue .lang-selector").forEach(el => {
      el.addEventListener("click", () => {
        const flagEv = new Event("ARCTERYXUICOMPONENTS.localeClick", { bubbles: true, cancelable: false });
        flagEv.initEvent("ARCTERYXUICOMPONENTS.localeClick", true, true);
        this.dispatchEvent(flagEv);
      });
    });

    setLinkClickedAnalyticsListeners(el, "#footerContent a", "footer");

    // Use this eventListener to update footer links for authenticated vs guest users
    window.addEventListener("update-user-auth", () => {
      this.isAuthenticated = getIsAuthenticated(this);
      isUserLoggedIn(this.root, ".SALE", this.isAuthenticated);
    });

    // Use this eventListener to hide footer for staff links via css
    window.addEventListener("hide-footer-links-for-staff", () => {
      toggleForStaff(this.root, ".SALE .isStaff", false);
    });

    // Use this eventListener to show footer for staff links via css
    window.addEventListener("show-footer-links-for-staff", () => {
      toggleForStaff(this.root, ".SALE .isStaff", true);
    });
  }

  addLanguageToRecallLink(el, language) {
    const recallLink = el.querySelector(".recall-link");
    if (recallLink) {
      const href = recallLink.getAttribute("href");
      recallLink.href = `${href}/${language}/procline-boot/`;
    }
  }
}

export default FooterSale;
